import orgzImage from "../images/OrgZ-GD.png";

/**
 * 🖨️ Impression du menu journalier
 * - info : { date, total, menuId }
 * - items : structure { Matin: {Sucré:[], ...}, Midi:{...}, Soir:{...} }
 * - groupeInfos : { nom, emoji, couleur }
 * - t : fonction de traduction
 */

export const printMenuJournalier = (info, items, groupeInfos = {}, t, articles = []) => {
  const { nom, emoji, couleur } = groupeInfos;

  //🔹 Formatage lisible de la date
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString(t("locale"), {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  // Construction du header (logo + nom groupe + date + total personnes)
  let html = `
    <div class="header">
      <img src="${orgzImage}" alt="Logo" class="logo" />
      <h1 class="group-title" style="color:${couleur};">
        ${emoji || "🍽️"} ${nom || t("Group")}
      </h1>
      <h2 class="date">${formatDate(info.date)}</h2>
      <h3 class="people">
        ${info.total} ${t("People")}
      </h3>
    </div>
    <hr/>
  `;

  // Parcours des moments (Matin / Midi / Soir)
  for (const moment of Object.keys(items)) {
    html += `<h2 class="moment">${t(moment)}</h2>`;
    const categories = items[moment];

     // Parcours des catégories (Sucré, Salé, Plat, Dessert, ...)
    for (const cat of Object.keys(categories)) {
        const lignes = (Array.isArray(categories[cat]) ? categories[cat] : [])
          .map(item => {
            const articleId =
              typeof item.articleId === "object"
                ? item.articleId._id
                : item.articleId;

            const article = articles.find(a => String(a._id) === String(articleId));

            const name = article?.name || "(article inconnu)";
            const qty = item.quantity ? ` (${item.quantity})` : "";

            return `${name}${qty}`;
            /*`
              <li>
                <span class="item-name">${name}</span>
                ${item.quantity ? `<span class="item-qty"> - ${item.quantity}</span>` : ""}
              </li>
            `;*/
          })
        .join(" - ");


  //// 🔹 On n'affiche la catégorie que si elle contient au moins un item
  // <ul class="item-list">${lignes}</ul>
  if (lignes) {
    html += `
      <div class="category">
        <div class="category-title">${t(cat)}</div>
         <div class="item-line">${lignes}</div>
        </div>
          `;
      }
    }
  }

  // Boutons d'action (non imprimés)
  html += `
    <div class="actions no-print">
      <button onclick="window.print()" class="btn print-btn">🖨️ ${t("Print")}</button>
      <button onclick="window.close()" class="btn close-btn">❌ ${t("Close")}</button>
    </div>
  `;


  // Ouverture de la fenêtre d'impression
  const printWindow = window.open("", "_blank", "width=800,height=600,scrollbars=yes,resizable=yes");

  // Injection du HTML + CSS
  printWindow.document.write(`
   <html>
    <head>
      <title>${t("DailyMenu")}</title>
      <style>
        body {
          font-family: 'Arial', sans-serif;
          padding: 20px;
          line-height: 1.6;
          text-align: center;
          color: #333;
        }

        .logo {
          max-height: 80px;
          margin-bottom: 10px;
        }

        .group-title {
          font-size: 1.8rem;
          margin: 5px 0;
          font-weight: bold;
        }

        .date {
          font-size: 1.2rem;
          margin: 5px 0;
          color: #555;
        }

        .people {
          font-size: 1rem;
          margin-bottom: 20px;
          color: #777;
        }

        .moment {
          margin-top: 25px;
          font-size: 1.4rem;
          color: #222;
          text-transform: capitalize;
        }

        .category {
          margin-top: 10px;
          text-align: left;
          display: inline-block;
          width: 80%;
        }

        .category-title {
          font-weight: bold;
          margin-bottom: 5px;
          font-size: 1.1rem;
          color: #444;
        }

        .item-line {
        font-size: 1rem;
        margin-bottom: 8px;
        color: #444;
        }

        .item-list {
          list-style: none;
          padding-left: 0;
        }

        .item-list li {
          padding: 4px 0;
          border-bottom: 1px solid #eee;
        }

        .item-name {
          font-weight: 500;
        }

        .item-qty {
          color: #666;
        }

        .actions {
          margin-top: 30px;
        }

        .btn {
          padding: 10px 18px;
          font-size: 14px;
          cursor: pointer;
          border-radius: 6px;
          border: none;
          margin: 0 10px;
        }

        .print-btn {
          background-color: #4caf50;
          color: white;
        }

        .close-btn {
          background-color: #f44336;
          color: white;
        }

        /* Masquer les boutons à l'impression */
        @media print {
          .no-print {
            display: none;
          }
        }
      </style>
    </head>
  <body>${html}</body>
</html>
`);
  
  printWindow.document.close();
};
